import { LOCAL_BASE_URL } from "../constants/constants";
import axiosRequestInterceptor from "../interceptor/axiosAPIRequestInterceptor";
import { logger } from "../utils/logger";

export default class AuthService {
	static token = null;
	static isRefreshing = false;
	static TOKEN_URL = LOCAL_BASE_URL + "/users/getToken";
	static MAX_RETRIES = 3;
	static api = axiosRequestInterceptor; // Create a single instance

	static getToken() {
		return this.token;
	}

	static async initializeToken() {
		try {
			await this.fetchToken();
		} catch (error) {
			logger.log("Failed to initialize token:", error);
			throw error;
		}
	}

	static async fetchToken() {
		try {
			const response = await this.api.post(this.TOKEN_URL);
			this.token = response.data.message; // Adjust based on actual response structure
			localStorage.setItem("authToken", this.token); // Store token in localStorage
			logger.log("Token fetched:", this.token);
		} catch (error) {
			logger.log("Token fetch failed:", error);
			throw error;
		}
	}

	static clearToken() {
		this.token = null;
		localStorage.removeItem("authToken");
	}
}
